<br />
<p class="text-justify">
    CONTRATO DE PRESTAÇÃO DE SERVIÇOS - CONECTIVIDADE SOCIAL<br />
    CAIXA X CLIENTE PESSOA FÍSICA  {{infoContratos.tipoContrato}}
</p>
<br />
<p class="text-justify">

    Pelo presente instrumento, a CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 - CEP
    70092 - 900, Brasília - DF, CNPJ 00360305/0001-04, doravante denominada CAIXA, {{infoContratos.razaoSocial}},
    com inscrição CPF/NIS n.º {{ inscricaoFormatada }}, doravante denominada CLIENTE, ajustam e celebram este
    convênio para os fins e sob as condições adiante indicadas.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 1ª - DO OBJETO
    O presente contrato tem por objeto possibilitar ao CLIENTE o acesso remoto, por meio de computador próprio, aos
    serviços disponíveis para o Perfil Pessoa Física {{infoContratos.tipoContrato}} no CONETIVIDADE SOCIAL.
</p>
<br />
<p class="text-justify">
    <strong>Perfil:</strong>: {{infoContratos.desPerfil}}

</p>
<br />

<strong>Serviços Disponíveis:</strong>

<ul>
    <li *ngFor="let servico of infoContratos.servicos">{{servico}}</li>
</ul>

<br />
<p class="text-justify">

    CLÁUSULA 2ª - DAS DEFINIÇÕES

    Para efeito deste contrato, considera-se:

    I - CONECTIVIDADE SOCIAL - Aplicativo que, através de acesso remoto, via Internet, disponibiliza serviços e
    informações ao CLIENTE. Marca registrada da CAIXA que identifica o conjunto de serviços e informações disponíveis
    através de conexão segura com o seu ambiente computacional. Ferramenta tecnológica associada à Internet que
    viabiliza a troca segura de informações entre as Instituições Financeiras;

    II - CONEXÃO - Forma de comunicação entre os computadores do CLIENTE e o ambiente computacional do CONECTIVIDADE
    SOCIAL;

    III - Internet - Rede de computadores interligados em todo o mundo, que se utiliza de um mesmo protocolo (TCP/IP) e
    de serviços de forma a permitir que os computadores instalados em diversas regiões geográficas possam entrar em
    contato uns com os outros e trocar informações;

    IV - PROTOCOLO TCP/IP - (Transmission Control Protocol / Internetworking Protocol) - Protocolo de comunicação básico
    da Internet para interconectar redes cujos componentes podem usar sistemas operacionais distintos;

    V - PROVEDOR - Máquinas Servidoras que possibilitam, às máquinas clientes, o acesso à rede Internet;

    VI - SENHA - código secreto que possibilita o acesso ao aplicativo disponibilizado. É pessoal e intransferível,
    razão pela qual a CAIXA não se responsabiliza pelo seu uso indevido;

    VII - ASSINATURA ELETRÔNICA - é o mecanismo apto a permitir e legitimar a autorização de acesso ao serviço
    requerido; sempre combinada com a senha.

    VIII - CERTIFICADO DIGITAL - Identificação eletrônica mediante o uso de chave pública e privada, utilizada para
    atestar a identidade dos atores envolvidos na conexão;

    IX - Ambiente Computacional do CONECTIVIDADE SOCIAL - Computadores de pequeno e grande porte onde estão contidos os
    dados e as informações referentes aos produtos e serviços oferecidos pela CAIXA;

    X - EMPRESA RAIZ - Pessoa Jurídica que se encontra no primeiro nível na cadeia de procurações, sendo detentora
    originária dos poderes relacionados ao seu perfil registrado no CONECTVIDADE SOCIAL.

    XI - PODER - Serviço disponibilizado no CONECTVIDADE SOCIAL, que pode ser utilizado pela EMPRESA RAIZ ou repassado
    por ela a terceiros.

    XII - CADEIA HORIZONTAL - cadeia de procurações que se encontram no mesmo nível de outorga ou substabelecimento.

    XIII - CADEIA VERTICAL - cadeia de procurações concedidas a Pessoas Jurídicas ou Físicas, que se encontram em
    diferentes níveis de outorga ou substabelecimento, cujas validades são condicionadas à validade das procurações
    precedentes.

    XIV - OUTORGANTE - Pessoa Jurídica ou Física que transfere seus poderes a outrem, no todo ou em parte, com ou sem
    prerrogativa de substabelecimento, por meio de Procuração Eletrônica do CONECTIVIDADE SOCIAL.

    XV - OUTORGADO - Pessoa Jurídica ou Física que representa o Outorgante através de Procuração Eletrônica do
    CONECTIVIDADE SOCIAL.

    XVI - SUBSTABELECEDOR - Pessoa Jurídica ou Física que, tendo recebido poderes através de Procuração Eletrônica do
    CONECTIVIDADE SOCIAL com prerrogativa de substabelecimento, os transfere a outrem.

    XVII - SUBSTABELECIDO - Pessoa Jurídica ou Física que recebe poderes de um substabelecedor por meio de Procuração
    Eletrônica do CONECTIVIDADE SOCIAL.

    XVIII - SÍTIO - é um conjunto de páginas acessíveis através de um endereço na Internet.

    IXX - Firewall - é o nome dado ao dispositivo de rede de computadores que tem por objetivo aplicar uma política de
    segurança com o objetivo de evitar acessos nocivos ou não autorizados.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 3ª - DA UTILIZAÇÃO

    O CLIENTE deverá dispor de certificado digital válido, gerado no padrão ICP-Brasil por Autoridade Certificadora - AC
    credenciada pelo Instituto Brasileiro de Tecnologia da Informação - ITI, e da respectiva senha, de caráter sigiloso,
    pessoal e intransferível.

    § 1º - Quaisquer irregularidades verificadas quando da operacionalização do CONECTIVIDADE SOCIAL deverão ser
    comunicadas à CAIXA e, se for o caso, o CLIENTE deverá solicitar imediatamente a suspensão do serviço.

    § 2º - A CAIXA poderá, a qualquer tempo, suspender e cancelar o acesso ao CONECTIVIDADE SOCIAL, caso verifique,
    através dos seus sistemas de segurança, que as operações realizadas pelo CLIENTE estão ou possam vir a estar
    comprometidas pelo uso de programas adulterados ou maliciosos que ameacem a integridade, a confidencialidade ou a
    disponibilidade das informações contidas no sítio do CONECTIVIDADE SOCIAL, comunicando, posteriormente, ao CLIENTE.
</p>
<br />
<p class="text-justify">

    CLÁUSULA 4ª - DAS OBRIGAÇÕES DA CAIXA

    A CAIXA se obriga a:

    I - disponibilizar acesso aos serviços disponíveis no CONECTIVIDADE SOCIAL, a qualquer tempo, no ambiente do próprio
    cliente;

    II - prestar as informações necessárias ao CLIENTE sobre os procedimentos de instalação e configuração dos
    aplicativos disponibilizados;

    III - manter Central de Atendimento à disposição do CLIENTE, nos dias e horários definidos pela CAIXA, para
    consultas sobre questões técnicas relativas à instalação, configuração, navegação e acesso ao CONECTIVIDADE SOCIAL;

    IV - processar ou encaminhar para processamento junto à instituição destinatária as informações recebidas do CLIENTE
    pelo CONETIVIDADE SOCIAL, desde que estas estejam consistidas e atendam aos requisitos de segurança ou quaisquer
    outros que venham a ser definidos pela CAIXA.

    V - assumir eventuais danos e/ou prejuízos causados por seus empregados e/ou prepostos no caso destes divulgarem ou
    utilizarem indevidamente dados ou informações a que tiverem acesso em virtude do presente contrato.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 5ª - DAS OBRIGAÇÕES DO CLIENTE

    O CLIENTE se obriga a:

    I - arcar com quaisquer despesas decorrentes dos serviços de telecomunicações, inclusive provedores de acesso à
    Internet, utilizados para conexão com o ambiente computacional do CONECTIVIDADE SOCIAL;

    II - fazer uso adequado da faculdade de outorga ou substabelecimento de Procuração Eletrônica, a que alude a
    CLÁUSULA 9ª deste contrato;

    III - guardar sigilo de sua senha, solicitando ou providenciando sua troca sempre que julgar necessário, bem como
    manter em lugar seguro seu Certificado Digital;

    IV - comunicar à CAIXA qualquer indício de irregularidade ou anormalidade apurada na utilização do CONECTIVIDADE
    SOCIAL;

    V - dispor, por seus próprios meios e iniciativas, de equipamentos e programas computacionais, além de todos os
    instrumentos necessários, compatíveis com a solução tecnológica do CONETIVIDADE SOCIAL e suas atualizações, que
    possibilitem a sua participação nas consultas aos dados e acesso aos serviços do CONECTIVIDADE SOCIAL;

    VI - assumir eventuais danos ou prejuízos causados à CAIXA ou a terceiros pelo uso indevido do CONETIVIDADE SOCIAL
    ou pela divulgação ou utilização indevida das informações a que este ou seus procuradores tiverem acesso em virtude
    do presente contrato;

    VII - responsabilizar-se integralmente pelos atos por ele praticados e solidariamente pelos executados por seus
    outorgados e substabelecidos;

    VIII - utilizar antivírus, firewall e demais programas sempre com versões atualizadas e registradas de acordo com a
    legislação vigente.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 6ª - DAS RESPONSABILIDADES DO CLIENTE

    É de inteira responsabilidade do CLIENTE toda e qualquer informação prestada no uso dos serviços disponíveis no
    CONECTIVIDADE SOCIAL, mediante a utilização de seu Certificado Digital e Senha.

    § 1º - Fornecer informações corretas e atualizadas, as quais, após atestada a autenticidade e consistência do
    Certificado Digital e senha utilizados, serão, para todos os efeitos legais, consideradas como prestadas pelo
    CLIENTE.

    § 2º - Usar adequadamente os serviços do CONECTIVIDADE SOCIAL. Comprovada sua utilização para fins ilícitos ou
    inadequados, sujeitar-se-á o CLIENTE às penalidades civis e penais cabíveis e à imediata suspensão ou revogação dos
    serviços.

    § 3º - Assumir inteira responsabilidade pela criação, extinção ou alteração de direitos ou deveres que venham a
    ocorrer em razão de informações incorretas, falsas, incompletas, adulteradas ou inconsistentes que sejam prestadas
    por ele, por seus outorgados ou por seus substabelecidos no CONECTIVIDADE SOCIAL, perante a CAIXA ou quaisquer
    outras entidades da Administração Pública direta ou indireta, ou ainda perante particulares que venham a ser
    prejudicados.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 7ª - DO DIREITO DE PROPRIEDADE

    A marca CONECTIVIDADE SOCIAL, o aplicativo, o sítio do CONECTIVIDADE SOCIAL e as imagens associadas à respectiva
    solução tecnológica são de propriedade da CAIXA ECONÔMICA FEDERAL, sendo vedado ao CLIENTE, nos termos da legislação
    em vigor, por qualquer forma, utiliza-los para obter lucros ou benefícios, para si ou para outrem, decorrentes do
    direito de uso objeto deste contrato.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 8ª - DAS ATUALIZAÇÕES E MODIFICAÇÕES

    A CAIXA, poderá agregar, retirar ou alterar os serviços e as formas de acesso ao CONECTIVIDADE SOCIAL, além de
    promover, a qualquer tempo, atualizações no aplicativo por meio de novas versões.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 9ª - DA UTILIZAÇÃO DO CONECTIVIDADE SOCIAL POR TERCEIROS

    O CLIENTE poderá, mediante outorga ou substabelecimento de Procuração Eletrônica, autorizar terceiros a transacionar
    em seu nome ou em nome de Empresa Raiz, observadas as regras de utilização desta prerrogativa definidas pela CAIXA.

    § 1º - A Procuração Eletrônica conferida pelo CLIENTE a um terceiro gera efeitos exclusivamente no âmbito do
    CONECTIVIDADE SOCIAL, podendo, todavia, ser aceita para outros processos que sejam disponibilizados pela CAIXA ou
    por outras entidades da Administração Pública direta ou indireta, exclusivamente em rotinas relacionadas às
    obrigações do CLIENTE junto a essas entidades e às informações transitadas pelo Conectividade Social.

    § 2º - As Procurações Eletrônicas têm validade de 12 meses a partir da data de emissão, devendo ser renovadas antes
    do seu vencimento a fim de não comprometer a continuidade dos serviços disponibilizados ao CLIENTE, a seus
    outorgados e a seus substabelecidos.

    § 3º - A validade da Procuração Eletrônica não está vinculada à validade do Certificado Digital, mas à validade das
    procurações na cadeia vertical superior e à validade do registro do CLIENTE e dos demais membros da cadeia de
    procurações no CONECTIVIDADE SOCIAL.

    § 4º - O CLIENTE somente poderá conceder Procuração Eletrônica a Pessoa Física que mantenha, com o este, espécie de
    vínculo empregatício passível de ser atestada pela CAIXA, por meio de seu próprio cadastro ou de outras informações
    que esta venha, a seu critério, entender mais adequadas.

    § 5º - No momento da outorga ou substabelecimento de uma Procuração Eletrônica, o CLIENTE transfere um conjunto de
    poderes recebidos do outorgante ou substabelecedor a um terceiro, para este transacionar em nome do outorgante ou em
    nome de Empresa Raiz no CONECTIVIDADE SOCIAL, podendo conferir a este o direito de substabelecer os poderes
    recebidos.

    § 6º - O CLIENTE ou seus procuradores Pessoa Física, estes desde que autorizados, poderão conceder Procuração
    Eletrônica a Pessoas Jurídicas; porém, estas não poderão repassar os poderes recebidos a outras Pessoas Jurídicas,
    ainda que o CLIENTE ou seus procuradores Pessoas Físicas tenham conferido ao substabelecido o direito de
    substabelecimento.

    § 7º - As transações efetuadas por um terceiro que tenha recebido uma Procuração Eletrônica do CLIENTE ou de seu
    procurador, quando este for autorizado a substabelecer poderes, gerarão os mesmos efeitos das transações efetuadas
    pelo próprio CLIENTE, recaindo sobre este a responsabilidade por tais transações, nos termos da CLÁUSULA 6ª e demais
    disposições deste contrato.

    § 8º - As procurações eletrônicas não poderão, em hipótese alguma, ser substabelecidas além do 5º nível vertical.

    § 9º - Cabe exclusivamente ao CLIENTE o controle do uso das procurações eletrônicas por ele ou por seus procuradores
    conferidas, podendo revogá-las a seu próprio critério e a qualquer tempo.

    § 10º - Ocorrendo a revogação ou expiração de uma Procuração Eletrônica, todas as outorgas ou substabelecimentos
    vinculados a esta procuração, na cadeia vertical inferior, serão igualmente revogados ou expirados pelo sistema.

    § 11º - Ocorrendo a revogação ou suspensão do Registro do CLIENTE, todas as outorgas e os substabelecimentos
    concedidos serão igualmente revogados pelo sistema.

    § 12º - A CAIXA poderá revogar, de ofício, qualquer Procuração Eletrônica que venha a ser considerada irregular ou
    potencialmente lesiva ao CLIENTE, aos demais usuários do CONECTIVIDADE SOCIAL ou a quaisquer entidades da
    Administração Pública Direta ou Indireta, ou ainda que venha a estar em discordância com as normas e regras
    estabelecidas pela CAIXA, mesmo que em razão de fatos ou circunstâncias supervenientes à sua outorga ou
    substabelecimento.

    § 13º - As procurações eletrônicas podem, ainda, ser aditadas a qualquer tempo, acrescentando-se a elas novos
    poderes, porém esta ação não confere novo prazo de validade a tais procurações.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 10ª - DO PRAZO DE DURAÇÃO

    As presentes disposições vigorarão a partir da data da aceitação pelo CLIENTE deste Instrumento de Contrato, por
    prazo indeterminado, até que seja denunciado ou revogado por uma das partes.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 11ª - DA DENÚNCIA

    Será facultada às partes a denúncia do presente contrato, a qualquer tempo, mediante comunicação formal.

    § 1º - Constituirá causa de denúncia, independente de aviso ou interpelação, judicial ou extrajudicial, respondendo
    a parte que der causa à rescisão, pelos prejuízos causados à outra:

    I - o descumprimento de quaisquer das cláusulas contratuais;

    II - a prática dolosa de qualquer ação ou deliberada omissão do CLIENTE visando a obtenção de vantagens ilícitas por
    meio do CONECTIVIDADE SOCIAL.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 12ª - DO PREÇO DA PRESTAÇÃO DOS SERVIÇOS

    Por liberalidade da CAIXA, não serão cobradas tarifas ao CLIENTE ou a seus procuradores pela prestação dos serviços
    que forem objeto do presente contrato.

    § 1º - A CAIXA pode a qualquer tempo vir a revogar tal liberalidade de isenção, passando a cobrar tarifa pela
    utilização de parte ou da totalidade dos serviços disponibilizados no CONECTIVIDADE SOCIAL, caso em que o CLIENTE
    será notificado, por meio de sua caixa postal no próprio CONECTIVIDADE SOCIAL, com antecedência mínima de 60
    (sessenta) dias. Na mesma notificação, constarão os valores das tarifas eventualmente cobradas por serviço ou
    conjunto de serviços, a forma de apuração e de cobrança.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 13ª - DAS DISPOSIÇÕES GERAIS

    O CLIENTE, após manifestar o aceite aos termos e condições deste contrato, terá acesso às orientações acerca dos
    procedimentos para a utilização da solução tecnológica do CONECTIVIDADE SOCIAL.

</p>
<br />
<p class="text-justify">

    CLÁUSULA 14ª - DO FORO

    Para dirimir quaisquer questões decorrentes deste instrumento, as partes elegem, com privilégio sobre qualquer
    outro, o foro da Seção Judiciária da Justiça Federal do Distrito Federal - DF.
</p>
